import Entity from "./Entity";
import Transaction from './Transaction'

const creditEntryEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'CreditEntryTypeEnum' }
};

export const createCreditEntryTypes = [
  'CREATION'
];

export default class CreditEntry {
  fields = {
    id: {
      value: null
    },
    type: {
      value: null
    },
    amount: {
      value: null
    },
    amount_tax_1: {
      value: null
    },
    amount_tax_2: {
      value: null
    },
    amount_tax_3: {
      value: null
    },
    amount_tax_4: {
      value: null
    },
    created_at: {
      value: null
    },
    transaction: {
      value: null
    },
    application_date: {
      value: null
    },
    payment: {
      value: null
    }
  }

  constructor({ type } = {}) {
    this.fields.type.value = type;
  }

  static createFromQueryValues(values) {
    const creditEntry = new this();

    for (let field in creditEntry.fields) {
      if (values.hasOwnProperty(field)) {
        switch(field) {
          case 'created_at':
            creditEntry.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          case 'transaction':
            creditEntry.fields[field].value = (values[field] === null) ?
            values[field] :
            Transaction.createFromQueryValues(values[field]);
            break;
          default:
            creditEntry.fields[field].value = values[field];
        }
      }
    }

    return creditEntry;
  }

  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      creditEntryEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }
}
